var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFunOfficeImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.03906 13.3793H13.7248V11.3168H3.03906V13.3793Z",
    fill: "#747779"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.51562 16.3699H9.32812V14.3168H7.51562V16.3699Z",
    fill: "#747779"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7248 8.30659H3.03906V10.3793H13.7248V8.30659Z",
    fill: "#747779"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_43_705",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.382812 0.369935H16.3828V16.3699H0.382812V0.369935Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_43_705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.03906 15.4324H2.38281C2.12394 15.4324 1.91406 15.6423 1.91406 15.9012C1.91406 16.16 2.12394 16.3699 2.38281 16.3699L6.57847 16.3699V14.3168H3.03906V15.4324Z",
    fill: "#747779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3808 15.4324H13.7245V14.3168H10.2656V16.3699L14.3808 16.3699C14.6397 16.3699 14.8495 16.16 14.8495 15.9012C14.8495 15.6423 14.6397 15.4324 14.3808 15.4324Z",
    fill: "#747779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83472 7.36908H13.9292C14.1802 7.36014 14.3811 7.15439 14.3811 6.90117V5.95039C14.3811 5.69149 14.1712 5.48164 13.9124 5.48164H2.85156C2.59269 5.48164 2.38281 5.69149 2.38281 5.95039V6.90117C2.38281 7.15439 2.58372 7.36014 2.83472 7.36908Z",
    fill: "#747779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7266 3.72946V4.54412H12.6641V3.72946C13.2097 3.53596 13.6016 3.01496 13.6016 2.40384V1.77884C13.6016 1.00343 12.9707 0.37259 12.1953 0.37259C11.4199 0.37259 10.7891 1.00343 10.7891 1.77884V2.40384C10.7891 3.01496 11.181 3.53596 11.7266 3.72946Z",
    fill: "#747779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.91406 3.72946V4.54412H8.85156V3.72946C9.39713 3.53596 9.78906 3.01496 9.78906 2.40384V1.77884C9.78906 1.00343 9.15822 0.37259 8.38281 0.37259C7.60738 0.37259 6.97656 1.00343 6.97656 1.77884V2.40384C6.97656 3.01496 7.36847 3.53596 7.91406 3.72946Z",
    fill: "#747779"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10156 3.72946V4.54412H5.03906V3.72946C5.58466 3.53596 5.97656 3.01496 5.97656 2.40384V1.77884C5.97656 1.00343 5.34572 0.37259 4.57031 0.37259C3.79491 0.37259 3.16406 1.00343 3.16406 1.77884V2.40384C3.16406 3.01496 3.55597 3.53596 4.10156 3.72946Z",
    fill: "#747779"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunOfficeImage);
export default __webpack_public_path__ + "static/media/fun_office_image.275747e06ad24bce453afd457415c2c3.svg";
export { ForwardRef as ReactComponent };